import { ICustomOccasion, Repeat } from '../../services/occasion-repeat'

type Day = Pick<ICustomOccasion, 'jm' | 'jd' | 'gm' | 'gd' | 'hd'>

export function leapDayMessage(repeat: Repeat, day: Day): string {
    if (repeat === 'jalaali' && day.jm === 12 && day.jd === 30)
        return 'در سال‌های غیرکبیسه، این رویداد در ۲۹ اسفند نمایش داده می‌شود.'
    if (repeat === 'gregorian' && day.gm === 2 && day.gd === 29)
        return 'در سال‌های غیرکبیسه، این رویداد در ۲۸ فوریه نمایش داده می‌شود.'
    if (repeat === 'hijri' && day.hd === 30)
        return 'در ماه‌های ۲۹روزه، این رویداد در روز ۲۹ ماه نمایش داده می‌شود.'
    return ''
}
